import {
  DataSyncIcon,
  KeyboardArrowRight,
  ListViewIcon,
} from '@/components/icons'
import CheckCircle from '@/components/icons/CheckCircle'
import { useAuthContext } from '@/features/auth/context'
import { CONFIG_SETUP_ROUTES } from '@/features/design-system/routes'
import { selectTheme } from '@/store/selectors/ThemeSelector'
import { mode_type } from '@/theme/types/constants'
import { Box, Button, Stack, Typography } from '@mui/material'
import clsx from 'clsx'
import { memo } from 'react'
import { useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import classes from './styles.module.scss'
import { OPERATIONS_ROUTES } from '@/constant/route'

type Props = {
  status: number
  commonDataStatus?: number
}

export const DONE_DISCOVER = 50
export const DONE_COMMON = 100

const BoxWrapper = memo(({ status, commonDataStatus }: Props) => {
  const { id } = useParams()
  const { interfaceId } = useAuthContext()

  const themeMode = useSelector(selectTheme)

  return (
    <Box className={classes.root}>
      <Button
        // disabled={status >= DONE_DISCOVER}
        component={Link}
        className={classes.boxItem}
        sx={{
          bgcolor: themeMode === mode_type.dark ? '#050B0F' : '#fff',
          boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
          '&:hover': {
            bgcolor: themeMode === mode_type.dark ? '#050B0F' : '#fff',
            boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
          },
        }}
        to={CONFIG_SETUP_ROUTES.discovery.to(id || (interfaceId+"") || '')}
      >
        <Stack className={classes.boxContent}>
          <Box
            bgcolor="background.overrideDefault"
            color="primary.main"
            className={classes.boxIcon}
          >
            <DataSyncIcon className={classes.icon} />
          </Box>
          <Typography color="primary.main" className={classes.title}>
            Discover <br /> Data
          </Typography>
          <Typography className={classes.description}>
            Discover data from <br /> installed hardware
          </Typography>
        </Stack>
        <Stack className={classes.boxStatus}>
          {status >= DONE_DISCOVER ? (
            <>
              <CheckCircle className={classes.completedIcon} />
              <Typography className={classes.start}>Completed</Typography>
            </>
          ) : (
            <Typography color="primary.main" className={classes.start}>
              Start
            </Typography>
          )}
        </Stack>
      </Button>
      <Button
        disabled={status < DONE_DISCOVER}
        component={Link}
        className={clsx(classes.boxItem, {
          [classes.boxPending]: status < DONE_DISCOVER,
        })}
        to={CONFIG_SETUP_ROUTES.setupSecond.to(id || (interfaceId+"") || '')}
        sx={{
          bgcolor: themeMode === mode_type.dark ? '#050B0F' : '#fff',
          boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
          '&.Mui-disabled': {
            bgcolor: themeMode === mode_type.dark ? '#050B0F' : '#fff',
            boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
            opacity: '0.4',
          },
          '&:hover': {
            bgcolor: themeMode === mode_type.dark ? '#050B0F' : '#fff',
            boxShadow: '0px 0px 20px 0px rgba(132, 132, 132, 0.20)',
          },
        }}
      >
        <Stack className={classes.boxContent}>
          <Box
            bgcolor="background.default"
            color="primary.main"
            className={classes.boxIcon}
          >
            <ListViewIcon className={classes.icon} />
          </Box>
          <Typography className={classes.title}>
            Common <br /> Data
          </Typography>
          <Typography className={classes.description}>
            Setup common data like <br /> pipes & pumps, plants,
            <br /> soil and more
          </Typography>
        </Stack>
        <Stack className={classes.boxStatus}>
          {status >= DONE_COMMON ? (
            <>
              <CheckCircle className={classes.completedIcon} />
              <Typography className={classes.start}>Completed</Typography>
            </>
          ) : status >= DONE_DISCOVER ? (
            <Typography className={classes.notComplete}>
              {commonDataStatus ?? 0}% Completed
            </Typography>
          ) : (
            <Typography className={classes.pending}>
              Pending Data Discovery
            </Typography>
          )}
        </Stack>
      </Button>

      {status === DONE_COMMON && (
        <Button
          component={Link}
          to={OPERATIONS_ROUTES.index.to}
          className={clsx(classes.boxItem, classes.comletedBox)}
        >
          <Typography className={classes.titleCompleted}>Dashboard</Typography>
          <Typography className={classes.subtitleCompleted}>
            Let’s Go
          </Typography>
          <KeyboardArrowRight className={classes.iconCompleted} />
        </Button>
      )}
    </Box>
  )
})

export default BoxWrapper
